import React, { Component } from "react";
import Titulo from "../../generico/TituloPagina";
import { trackPromise } from 'react-promise-tracker';
import Select from "react-select";

import PrestamoCU from "../../generico/Prestamo/PrestamoCU"
import Popup from 'react-popup';
import CampoNroTelefono from "../../generico/CampoNroTelefono"
import PrestamoService from "../../../services/solicitudes/PrestamoService"
import $ from "jquery";
import DatosSocio from "../../generico/DatosSocio"
import { mensajeExito } from '../../generico/MensajeSistemaToast';
import { formatoSeparadorMiles, phoneNumberValido, phoneFormatter, splitImporte } from "../../generico/utils/FormatoInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudArrowUp, faPaperPlane  } from "@fortawesome/free-solid-svg-icons";

export default class Prestamo extends Component {

  constructor(props) {
    super(props);
    this.refPrestamoCU = React.createRef();
    
    this.state = {
      plazo: undefined,
      monto: undefined,
      email: undefined,
      tipo:undefined, 
      telefono: undefined,
      tiposPrestamos: undefined, 
      phoneFormat: undefined
    };
  }

  inicializarEstados = () => {
   
    this.setState({
      plazo: undefined,
      monto: undefined,
      email: undefined,
      tipo:undefined, 
      telefono: undefined,
      phoneFormat: undefined,
      tiposPrestamos: undefined
  }, this.enableNext
  );
  
 
  }
  enableNext(){
    sessionStorage.setItem("msg", "SI");
    window.location.reload();
    
  
  }

 

  componentDidMount() {
    if (sessionStorage.getItem("msg") !== null) {
      mensajeExito("Solicitud de Préstamo enviada con éxito.");
      sessionStorage.removeItem("msg")
    }
    this.setState({ tiposPrestamos: this.getTiposPrestamos() });
  }

  getTiposPrestamos() {
    var prestamos = [];
    trackPromise(
      PrestamoService.getTiposPrestamos()
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);

          if (jsonData.codigo === 0) {
            for (var i = 0; i < jsonData.datos.length; i++) {
              prestamos.push({
                value: jsonData.datos[i].datosTiposPK.numero,
                label:
                  jsonData.datos[i].descripcion,
              });
            }
          }
          else {
            Popup.queue(this.notifiPopup("Error", jsonData.desRetorno));
            return;
          }
        }

        ));
    return prestamos;
  }

  handleChangeSelector = (selectedOption) => {
    if (selectedOption === null)
    this.setState({
      plazo: undefined
  });
    else
    this.setState({
      plazo: selectedOption.value
  });
      
  };

  obtenerPlazo() {
    var options = [];
    options.push({value: 0,label: "--seleccione--"},{value: 6,label: "6 MESES"},
    {value: 12,label: "12 MESES"},{value: 18,label: "18 MESES"},{value: 24,label: "24 MESES"},
    {value: 36,label: "36 MESES"}, {value: 42,label: "42 MESES"}, {value: 48,label: "48 MESES"},
    {value: 54,label: "54 MESES"}, {value: 60,label: "60 MESES"}, {value: 96,label: "96 MESES"},
    {value: 108,label: "108 MESES"}, {value: 120,label: "120 MESES"}, {value: 132,label: "132 MESES"},
    {value: 144,label: "144 MESES"}, {value: 156,label: "156 MESES"}, {value: 180,label: "180 MESES"},
    {value: 192,label: "192 MESES"}, {value: 204,label: "204 MESES"}, {value: 216,label: "216 MESES"},
    {value: 228,label: "228 MESES"}, {value: 240,label: "240 MESES"});
  
    return (
      <div className="form-group">
        <label className="input-label-bold">Plazo *</label>
        <div className="is-invalid" id="plazo-div">
        <Select name="plazo"
          defaultValue={this.state.plazo}
          onChange={this.handleChangeSelector}
          placeholder="-- seleccione --"
          options={options}
          isClearable
          noOptionsMessage={() => 'SIN DATOS'}
        />    
        </div>         
      </div>
    );
  }  
  

  selectorValue = (dataFromChild) => {
    //console.log(dataFromChild)
    this.setState({
      tipo: dataFromChild,
      
    });
  };

  phoneSelectorValue = (dataFromChild) => {
    
    this.setState({
      phoneFormat: dataFromChild,
      telefono: this.formatearPhone(dataFromChild)
    });
  };

  formatearPhone = (valor) => {
    valor = valor.replace("(", "");
    valor = valor.replace(")", "");
    valor = valor.replace("-", "");
  
    return valor;

  }
  
  reemplazarPunto = (valor) => {

    var resultado = valor.replace(".", "");
    var original = resultado;
    var reemplazo = true;
    while (reemplazo) {
      resultado = resultado.replace(".", "");
      if (resultado === original)
        reemplazo = false
      else
        original = resultado

    }
    return resultado;
  };

 
  
  validarEnviar = (elemento) => {
    
      $.validator.setDefaults({
        submitHandler: ()  =>{
          
        this.enviar()
        }
      });
      $("#idPrestamoForm").submit(function(e) {

        
        e.preventDefault();
        $.validator.addMethod(
          "prefijos",
          function (value, element) {
    
            return phoneNumberValido(element.value);
    
          }
        );
        $.validator.addMethod(
          "prefijoMin",
          function (value, element) {
            var tam = phoneFormatter(element.value)
            if (tam.length < 10)
              return false
            return true;
    
          }

        );

        $.validator.addMethod(
          "valorMin",
          function (value, element) {
            var valor = splitImporte(element.value)
            if (valor < 1000000)
              return false
            return true;
    
          }

        );
        var data = {};
        var dataArray = $('#idPrestamoForm').serializeArray();
      
        for(var i=0;i<dataArray.length;i++){
          //console.log(dataArray[i])
          data[dataArray[i].name] = dataArray[i].value;
          if(dataArray[i].name ==="tipo" && dataArray[i].value === ""){
            e.target[0].classList.add("error")
            e.target[0].classList.add("is-invalid")
           
            e.target[0].name="prestamo"
            e.target[0].classList.add("is-invalid")
            var prueba = document.getElementById('prueba')
            prueba.classList.add("prueba")
            
          }
            if(dataArray[i].name ==="tipo" && dataArray[i].value !== ""){
            e.target[0].name=""
            var prueba = document.getElementById('prueba')
            prueba.classList.remove("prueba")
            }

            if(dataArray[i].name ==="plazo" && dataArray[i].value === ""){
              var prueba = document.getElementById('plazo-div')
            prueba.classList.add("prueba")
              
            e.target[2].name="plazo"
            }
            if(dataArray[i].name ==="plazo" && dataArray[i].value !== ""){
            e.target[2].name=""
            var prueba = document.getElementById('plazo-div')
            prueba.classList.remove("prueba")
            }
            
        }
    
      }).validate(
        {
        rules: {
          prestamo: {
            required: true,
           
          },
          plazo: {
            required: true,
          },
          monto: {
            required: true,
            valorMin: { valorMin: false },
          },
          telefono: {
            required: true,
            prefijos: { prefijos: false },
            prefijoMin: { prefijoMin: false },

          },
          email: {
            email: true,
          },

         
        },
        messages: {
          prestamo: {
            required: "Este campo es requerido",
          },
          plazo: {
            required: "Este campo es requerido",
          },
          monto: {
            required: "Este campo es requerido",
            valorMin: "El monto solicitado debe ser como minimo 1.000.000"
          },
          telefono: {
            required: "Este campo es requerido",
            prefijos: "Número inválido",
            prefijoMin: "Número inválido",
          },
          email: {

            email: "Email inválido",
          },
         
        },
        errorElement: "span",
        errorPlacement: function (error, element) {
          error.addClass("invalid-feedback");
          $(element).addClass("is-invalid");
          element.closest(".form-group").append(error);
         
        },
      
        unhighlight: function (element, errorClass, validClass) {
          $(element).removeClass("is-invalid");
        },
    });
    
  };

  onChangeMonto = (event) => {
    var montoActual = this.reemplazarPunto(event.target.value)
    
    

    this.setState({
      monto: montoActual
    });
    
  }

  onChangeEmail = (event) => {
    var re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    var mail = event.target.value
    if(mail==="")
    return;
    if(!re.test(mail)){
      $("#errmsg").html("Email inválido").show().css("color","red");;
    //  event.target.classList.add("is-invalid")
  
      return;
    }
    $("#errmsg").hide()

    this.setState({
      email: mail
    });
    
  }

  validarMonto = () =>{
     $("#montoerr").hide()
   
   
    if(this.state.monto < 1000000){
      $("#montoerr").html("El monto solicitado debe ser como minimo 1.000.000").show().css("color","red");;
      return;
    }

  }


  notifiPopup = (titulo, mensaje) =>
  Popup.register({
    title: titulo,
    content: mensaje,
    buttons: {
      right: [
        {
          text: "Aceptar",
          className: "success",
          action: function () {
            Popup.close();
          },
        },
      ],
    },
  });

  enviar(){
    
   
   trackPromise(
      PrestamoService.confirmarSolicitud(this.state.monto,this.state.plazo,this.state.tipo, this.state.telefono, this.state.email)
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          
          if(jsonData.codigo === 0){
            this.inicializarEstados()
           
           
          
           
          }
          else{
            Popup.create({
              title: "Solicitud de Prestamo",
              content: jsonData.mensaje,
              buttons: {
                  right: [{
                      text: 'Aceptar',
                      className: 'success',
                      action: function () {
                          
                          Popup.close();
                      }
                  }]
              }
            });
          }
        }, (error) =>{
          Popup.queue(this.notifiPopup("Error","Lo sentimos, ha ocurrido un inconveniente."));
        }
        ).catch(err =>{
          if(err.message === "Cannot read property 'status' of undefined"){
            Popup.queue(this.notifiPopup("Error","Lo sentimos, se ha perdido la conexión con el servidor."));

          }
        })
        ).catch(err =>{
          Popup.queue(this.notifiPopup("Error","Lo sentimos, ha ocurrido un inconveniente."));
        });


   
  }  


  render() {
   
    var prestamos = this.state.tiposPrestamos
  
    return (
      <div className="content-wrapper">
        <Titulo texto="Solicitud de Prestamo"/>
          <section className="content">
          <form id="idPrestamoForm">
            <div className="container">
              <div className="row justify-content-md-center">
                <div className="col-md-10">
                  <div className="card">
                    <div className="card-header">
                      <DatosSocio/>
                    </div>
                    <div className="card-body">     
                      <div className="row">
                        <div className="col-md-12">
                          {<PrestamoCU ref={this.refPrestamoCU} titulo="Tipo de Prestamo" presentacion="SELECT" selectorValue={this.selectorValue.bind(this)} itemSelected={this.state.tipo} prestamos={prestamos}/>}
                        </div>
                      
            
                        <div className="col-md-12">                          
                          {this.obtenerPlazo()}
                        </div>

                        <div className="col-12">                          
                          <div className="form-group">
                            <label className="input-label-bold">Monto (Mínimo 1.000.000) *</label>
                            <input type="text" name="monto" onKeyUp={formatoSeparadorMiles} maxLength="19" required placeholder="monto a solicitar" 
                              className="form-control input-box" style={{textTransform: "lowercase"}} defaultValue={this.state.monto} onBlur={e => this.onChangeMonto(e)}/>
                          </div>
                        </div>
                      <div className="col-12">
                      <CampoNroTelefono label={"Teléfono del contacto"} ref={this.refTelefono} phoneSelectorValue={this.phoneSelectorValue.bind(this)} phoneSelector={this.state.phoneFormat}/>   
                      </div>
                        <div className="col-12">                          
                          <div className="form-group">
                            <label className="input-label-bold">Correo Electrónico</label>
                            <input name="email" type="mail" style={{textTransform: "lowercase"}} placeholder="email"
                              className="form-control input-box" defaultValue={this.state.email} 
                              onChange={(val) => {
                                this.setState({ email: val.target.value });
                              }}/>
                         
                          </div>
                        </div>
                        </div>
                    </div>  
                    <div className="card-footer">
                      <div className="row">
                        <div className="col-lg-10 col-md-8">
                        <label className="input-label-bold-obligatorio">
                          (*) Campos Obligatorios
                      </label> 
                        </div>
                        <div className="col-lg-2 col-md-4">
                        <button className="btn btn-cu-primary" onClick={()=>this.validarEnviar()}>
                       <FontAwesomeIcon icon={faPaperPlane} /> Enviar
                      </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </form>
          </section>
      </div>
    );
  }
}
